import 'react-multi-carousel/lib/styles.css'

import { Children, ReactNode } from 'react'
import Carousel from 'react-multi-carousel'

interface ImagesCarouselProps {
  children: ReactNode
}

export function ImagesCarousel({ children }: ImagesCarouselProps) {
  return (
    <Carousel
      additionalTransfrom={0}
      autoPlaySpeed={3000}
      centerMode={false}
      className="w-full"
      containerClass="container"
      dotListClass=""
      draggable={Children.count(children) > 1}
      focusOnSelect={false}
      itemClass=""
      keyBoardControl
      minimumTouchDrag={80}
      pauseOnHover
      renderArrowsWhenDisabled={false}
      renderButtonGroupOutside={false}
      renderDotsOutside={false}
      responsive={{
        desktop: {
          breakpoint: {
            max: 3000,
            min: 1024,
          },
          items: 1,
        },
        mobile: {
          breakpoint: {
            max: 464,
            min: 0,
          },
          items: 1,
        },
        tablet: {
          breakpoint: {
            max: 1024,
            min: 464,
          },
          items: 1,
        },
      }}
      rewind={false}
      rewindWithAnimation={false}
      rtl={false}
      shouldResetAutoplay
      showDots={Children.count(children) > 1}
      sliderClass=""
      slidesToSlide={1}
      swipeable={Children.count(children) > 1}
    >
      {children}
    </Carousel>
  )
}
